export default __webpack_public_path__ + "static/media/logo-short.5614ec18.svg";